class DesktopNavDrawer extends DrawerElement {
  constructor() {
    super();

    this.drawerOpen = false;
    this.level_2_active = false;

    this.levelOneParentLinks = this.querySelectorAll('[data-menu-level="1"] a[data-position]');
    this.levelOneLinks = this.querySelectorAll('[data-menu-level="1"] a');

    this.drawerContent = document.querySelector('#drawer-content');

    this.levelOneParentLinks.forEach((element) => {
      element.addEventListener('click', this.handleLevelOneClick.bind(this));
    });

    this.querySelectorAll('[data-aux-menu-trigger]').forEach((element) => {
      element.addEventListener('click', this.handleAuxTriggerClick.bind(this));
    });

    this.addEventListener('drawer:toggle', this.onDrawToggleEvent.bind(this));
    this.addEventListener('drawer:close', this.onDrawCloseEvent.bind(this));

    window.addEventListener('resize', this.onResize);
  }

  activate() {
    console.log('activate desktop nav');
    this.setAttribute('aria-hidden', false);
    this.style.zIndex = 1;
    this.levelOneParentLinks.forEach((element) => {
      element.setAttribute('aria-expanded', false);
    });
  }

  onDrawToggleEvent(event) {
    console.log('onDrawToggleEvent');
    if (this.activelevelOne) {
      this.activelevelOne.classList.add('hidden');
    }
    this.drawer.classList.remove('level-2-active');

    if (this.activeSubMenu) {
      this.activeSubMenu.classList.add('hidden');
      this.activeSubMenu = null;
      if (this.activeTrigger) {
        this.activeTrigger.classList.remove('!text-black');
      }
      this.activeTrigger = null;
      this.activeLevelOneParent.classList.remove('bg-menu-dropdown-svg', 'text-black', 'after:!-right-10');
    }
    this.classList.remove(`${this.activeNavMenuId}-active`);
    this.activeNavMenuId = event.detail.triggerElement.dataset.menuId;
    this.activelevelOne = this.querySelector(`[data-menu-id="${this.activeNavMenuId}"]`);
    this.classList.add(`${this.activeNavMenuId}-active`);

    if (this.activelevelOne) {
      this.activelevelOne.classList.remove('hidden');
    }

    header.querySelectorAll('[data-panel-transition]').forEach((x) => {
      x.classList.remove('!text-black');
    });

    this.activeTrigger = event.detail.triggerElement;
    this.activeTrigger.classList.add('!text-black');

    this.header.classList.add('desktop-drawer-open');
  }

  focusLevelOne(triggerElement) {
    window.trapFocus(this.activelevelOne, null, triggerElement);
  }

  onDrawCloseEvent(event) {
    this.drawerOpen = false;
    this.resetSubNavs();
  }

  resetSubNavs() {
    if (this.activeSubMenu) {
      this.activeSubMenu.classList.add('hidden');
      this.activeSubMenu.classList.replace('opacity-100', 'opacity-0');
      this.activeSubMenu = null;
    }
    this.drawer.classList.remove('level-2-active');
    if (this.activeLevelOneParent) {
      this.activeLevelOneParent.classList.remove(
        'after:opacity-100',
        'bg-menu-dropdown-svg',
        'text-black',
        'after:!-right-10',
      );
      this.activeLevelOneParent = null;
    }
  }

  escape() {
    if (this.activeLevelOneParent) {
      console.log('go back to level one');
      this.closeLevelTwoMenu(this.activeLevelOneParent);
      this.levelOneParentLinks.forEach((element) => {
        element.setAttribute('aria-expanded', 'false');
      });
      // window.releaseFocus();
    } else {
      console.log('close panel with escape');
      window.panelManager.dispatch('CLOSE_PANEL');
    }
  }

  openLevelTwoMenu(clickedMenuLink) {
    console.log('open new nav');
    const parentPosition = clickedMenuLink.dataset.position;
    const subMenu = this.querySelector(`[data-triggered-by="${parentPosition}"]`);
    let requiresTransition = !this.drawer.classList.contains('level-2-active');
    clickedMenuLink.classList.add('after:opacity-100', 'text-black', 'after:!-right-10');
    clickedMenuLink.setAttribute('aria-expanded', true);
    this.activeLevelOneParent = clickedMenuLink;
    this.activeSubMenu = subMenu;
    this.level_2_active = true;
    this.drawer.classList.add('level-2-active');
    if (!subMenu.querySelector('.desktop-menu--image')) {
      if (this.drawerContent.classList.contains('md:group-[.level-2-active]:w-27')) {
        this.drawerContent.classList.remove(
          'md:group-[.level-2-active]:w-27',
          'lg:group-[.level-2-active]:w-28',
          '2xl:group-[.level-2-active]:w-29',
        );
        this.drawerContent.classList.add(
          'md:group-[.level-2-active]:w-26.5',
          'lg:group-[.level-2-active]:w-26.5',
          '2xl:group-[.level-2-active]:w-26.5',
        );
        requiresTransition = true;
      }
    } else {
      if (this.drawerContent.classList.contains('md:group-[.level-2-active]:w-26.5')) {
        this.drawerContent.classList.remove(
          'md:group-[.level-2-active]:w-26.5',
          'lg:group-[.level-2-active]:w-26.5',
          '2xl:group-[.level-2-active]:w-26.5',
        );
        this.drawerContent.classList.add(
          'md:group-[.level-2-active]:w-27',
          'lg:group-[.level-2-active]:w-28',
          '2xl:group-[.level-2-active]:w-29',
        );
        requiresTransition = true;
      }
    }

    requestAnimationFrame(() => {
      subMenu.classList.remove('hidden');
      requestAnimationFrame(() => {
        const showSubmenu = () => {
          subMenu.classList.replace('opacity-0', 'opacity-100');
          waitForTransitionEnd(subMenu).then(() => {
            window.trapFocus(subMenu, subMenu.querySelector('a'), clickedMenuLink, false);
          });
        };

        if (!requiresTransition) {
          showSubmenu();
        } else {
          waitForTransitionEnd(this.drawerContent, 'width').then(() => {
            showSubmenu();
          });
        }
      });
    });
  }

  swapLevelTwoMenu(clickedMenuLink) {
    window.releaseFocus();
    // window.trapFocus();
    this.activeLevelOneParent.classList.remove('after:opacity-100', 'text-black', 'after:!-right-10');
    this.activeLevelOneParent.setAttribute('aria-expanded', false);
    this.activeSubMenu.classList.replace('opacity-100', 'opacity-0');
    this.activeSubMenu.classList.add('hidden');

    this.openLevelTwoMenu(clickedMenuLink);
    console.log('close child and open new');
  }
  handleLevelOneClick(event) {
    event.preventDefault();
    event.stopPropagation();

    const clickedMenuLink = event.currentTarget;
    const parentPosition = clickedMenuLink.dataset.position;
    const subMenu = this.querySelector(`[data-triggered-by="${parentPosition}"]`);

    if (this.activeSubMenu === subMenu) {
      // close a sub menu - click an item with already open sub-menu
      this.closeLevelTwoMenu(clickedMenuLink);
    } else if (this.activeLevelOneParent) {
      // close a sub menu, then open a sub menu - clicking another item with sub menu
      this.swapLevelTwoMenu(clickedMenuLink);
    } else {
      // open a sub menu - clicking for first time
      this.openLevelTwoMenu(clickedMenuLink);
    }

    // navigate to a new page - clicking an item with no sub menu < this doesn't happen in here, event not bound to these links
  }

  closeLevelTwoMenu(clickedMenuLink) {
    this.activeLevelOneParent.classList.remove('after:opacity-100', 'text-black', 'after:!-right-10');
    this.activeLevelOneParent.setAttribute('aria-expanded', 'false');
    this.activeSubMenu.classList.replace('opacity-100', 'opacity-0');
    waitForTransitionEnd(this.activeSubMenu).then(() => {
      window.releaseFocus();
      this.activeSubMenu.classList.add('hidden');
      this.drawer.classList.remove('level-2-active');
      this.activeSubMenu = null;
      this.activeLevelOneParent = null;
    });
    setTimeout(() => {}, 300);
  }

  handleAuxTriggerClick(event) {
    event.currentTarget.parentElement.classList.toggle('expanded');
    event.currentTarget.setAttribute('aria-expanded', event.currentTarget.parentElement.classList.contains('expanded'));
  }

  onResize = () => {
    if (window.innerWidth < 1200 && this.drawerOpen) {
      // this.onBackgroundClick();
    }
  };
}

customElements.define('desktop-nav-drawer', DesktopNavDrawer);
